import { FileText, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function MentionsLegales() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Navigation */}
      <nav className="bg-white border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex items-center gap-2">
              <FileText className="h-6 w-6 text-[#2563EB]" />
              <span className="font-bold text-lg text-[#0F172A]">CFE Auto-Entrepreneur</span>
            </a>
            <Button 
              variant="ghost" 
              onClick={() => navigate('/')}
              className="text-[#475569]"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Retour
            </Button>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-slate-200 p-8 sm:p-12">
          <h1 className="text-3xl font-bold text-[#0F172A] mb-8">Mentions légales</h1>
          
          <div className="legal-content text-[#475569]">
            <h2 className="text-[#0F172A] font-semibold">1. Éditeur du site</h2>
            <p>
              Le site cfe-autoentrepreneur.fr est édité par une société de services aux entreprises.
            </p>
            <p>
              <strong>Adresse :</strong> France<br />
              <strong>Email :</strong> contact@cfe-autoentrepreneur.fr
            </p>

            <h2 className="text-[#0F172A] font-semibold">2. Hébergement</h2>
            <p>
              Le site est hébergé par des prestataires professionnels garantissant la sécurité 
              et la disponibilité des services.
            </p>

            <h2 className="text-[#0F172A] font-semibold">3. Propriété intellectuelle</h2>
            <p>
              L'ensemble des contenus présents sur le site (textes, images, logos, etc.) sont 
              protégés par le droit de la propriété intellectuelle. Toute reproduction, même 
              partielle, est interdite sans autorisation préalable.
            </p>

            <h2 className="text-[#0F172A] font-semibold">4. Données personnelles</h2>
            <p>
              Les informations collectées via le formulaire de déclaration CFE sont utilisées 
              exclusivement pour la génération de votre document. Elles ne sont pas transmises 
              à des tiers.
            </p>
            <p>
              Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de 
              suppression de vos données. Pour exercer ces droits, contactez-nous à 
              contact@cfe-autoentrepreneur.fr.
            </p>

            <h2 className="text-[#0F172A] font-semibold">5. Cookies</h2>
            <p>
              Le site utilise des cookies techniques nécessaires à son bon fonctionnement. 
              Aucun cookie de traçage publicitaire n'est utilisé.
            </p>

            <h2 className="text-[#0F172A] font-semibold">6. Limitation de responsabilité</h2>
            <p>
              <strong>Ce service n'est pas affilié à l'administration fiscale française.</strong>
            </p>
            <p>
              <strong>Ce service ne constitue pas un conseil fiscal.</strong> Il s'agit d'un outil 
              d'aide au remplissage du formulaire 1447-C-SD.
            </p>
            <p>
              <strong>Le document généré doit être vérifié par l'utilisateur avant envoi</strong> aux 
              services compétents.
            </p>
            <p>
              L'éditeur ne saurait être tenu responsable des erreurs ou omissions dans les 
              informations fournies par l'utilisateur, ni des conséquences liées à l'utilisation 
              du document généré.
            </p>

            <h2 className="text-[#0F172A] font-semibold">7. Droit applicable</h2>
            <p>
              Les présentes mentions légales sont soumises au droit français. En cas de litige, 
              les tribunaux français seront seuls compétents.
            </p>

            <p className="text-sm text-[#94A3B8] mt-8">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-4 text-center text-sm text-[#94A3B8] border-t border-slate-200">
        <p>© {new Date().getFullYear()} CFE Auto-Entrepreneur. Tous droits réservés.</p>
      </footer>
    </div>
  );
}
